import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import ServicePackages from "./sections/ServicePackages";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesOverview />
      <ServicePackages />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}